import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "a-minorAction showPopover",
  href: "javascript:void(0)"
}
const _hoisted_3 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_4 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import moment from "dayjs";
import { popover as vPopover } from "uiv";
import { DevelopStrengthProgressApiModel } from "../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-member-develop-line',
  props: {
    model: {}
  },
  setup(__props: any) {

const props = __props;

const displayDate = (dateString: string): string => {
  return dateString ? moment(dateString).format("DD/MM/YYYY") : "";
};

return (_ctx: any,_cache: any) => {
  return (_ctx.model)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", null, [
          _createElementVNode("u", null, [
            _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_2, [
              _createTextVNode(_toDisplayString(_ctx.model.strengthItemDisplayTitle), 1)
            ])), [
              [
                _unref(vPopover),
                {
            title: _ctx.model.strengthItemDisplayTitle,
            content: _ctx.model.strengthItemShortDefinition,
          },
                void 0,
                { right: true }
              ]
            ])
          ]),
          _createTextVNode(": "),
          (_ctx.model.lastDayIndex > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Day " + _toDisplayString(_ctx.model.lastDayIndex) + " - ", 1),
                (_ctx.model.lastReadActionTime)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(displayDate(_ctx.model.lastReadActionTime)), 1))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, "not started"))
        ]),
        _hoisted_5
      ]))
    : _createCommentVNode("", true)
}
}

})